import React from 'react';
import Globals from "../hooks/globals"

const Hero = ({ className, align, size, font, children }) => {
    let fAlign = (align === undefined) ? 'text-center' : align
    let fSize = (size === undefined) ? 'text-6xl lg:text-8xl mx-10' : size
    let fFont = (font === undefined) ? 'font-extrabold' : font
    return (
        <h1 className={Globals.classNames(className, fAlign, fSize, fFont, "font-serif")}>{children}</h1>
    );
}

export default Hero;